import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Stack } from 'react-bootstrap';
// import '../../Scss/Form.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import RHFTextField from '../../FunctionalComponent/FormElement/RHTextField';
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import RHSelectField from '../../FunctionalComponent/FormElement/RHSelectField';
import { useCreate_Update_sizeMutation, useGetsizeMutation } from '../../Redux/SizeSlice';
import { useDispatch, useSelector } from 'react-redux';
// import { Chip } from '@mui/material';
import Select from 'react-select';
import { useCreateSpecificationMutation, useGetSpecificationsTypeQuery } from '../../Redux/specification/specificationApi';
import { useGetCategoriesListQuery } from '../../Redux/category/categoryApi';
import { useProductListMutation } from '../../Redux/ProductSlice';
import { useCreateBannerMutation, useGetBannerQuery } from '../../Redux/banner/bannerApi';
import BannerFileUpload from '../../FunctionalComponent/FormElement/BannerFileUpload';




const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
];

function CreateBanner(props) {
    const { setOpen, BannerData, open } = props;
    const [CreateUpdateSizeFunc] = useCreate_Update_sizeMutation();
    const { data: listData, isLoading: listLoading } = useGetBannerQuery();

    const [GetsizeFunc] = useGetsizeMutation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [chipsOptions, setChipsOptions] = useState({});
    const [productOptions, setProductOptions] = useState([]);
    const [productListFn, { data: productList, isSuccess, error, isLoading }] = useProductListMutation();

    // if (!productList?.response?.length) {

    console.log(BannerData?.id, "BannerData");

    let [img, setImg] = useState({
        image: ""
    })

    const { data: categoryData } = useGetCategoriesListQuery();
    const { data: specificationsTypeData } = useGetSpecificationsTypeQuery()

    let title = {
        header: `Banner ${BannerData?.id ? 'Update' : 'Add'}`,
        submit: `${BannerData?.id ? 'Update' : 'Save'}`
    };

    console.log(chipsOptions, "chipsOptions");
    let initialState = {
        id: BannerData?.id || '',
        categoryId: '',
        productId: [],
        image: '',
        status: true,
        type: (BannerData?.bannerType == "offerSection" || BannerData?.bannerType == "bannerImage") ? 'normalImage' : ''
    };

    // const schema = Yup
    //     .object({
    //         name: Yup
    //             .string()
    //             .required()
    //             .strict(true)
    //             .trim('White spaces before and after are not allow'),
    //         slug: Yup
    //             .string()
    //             .required()
    //             .strict(true)
    //             .trim('White spaces before and after are not allow'),
    //         // status: Yup.string().required(),
    //         status: Yup.string().required('Status is required'),
    //     })
    //     .required();

    const methods = useForm({
        // resolver: yupResolver(schema),
        defaultValues: initialState,
        mode: 'all',
    });
    const {
        handleSubmit,
        reset,
        setError,
        setValue,
        getValues,
        watch
    } = methods;

    const [fn, { }] = useCreateBannerMutation()

    const onSubmit = (e) => {
        const data = getValues();
        if (data) {
            fn({ ...data, image: img?.image?.url }).then(async (res) => {
                if (res?.data?.statusCode == 200) {
                    setOpen(false)
                }
            })
        }
    }
    const yy = watch();

    const handleDelete = () => {
        console.info('You clicked the delete icon.');
    };
    useEffect(() => {
        if (BannerData?.id) {
            // GetsizeFunc(BannerData?.id).then(res => {
            //     const getsizedata = res?.data?.response
            //     Object.keys(initialState).forEach((fieldname) => {
            //         setValue(fieldname, getsizedata[`${fieldname}`]);
            //     })

            // })
            console.log(listData, "listData");
            if (listData?.response?.id) {
                Object.keys(initialState).forEach(it => {
                    setValue(it, listData?.response?.[it])
                })
            }
        }
    }, [BannerData?.id])

    const handleClose = () => {
        setOpen(false);
    };

    // const [chips, setChips] = useState([]);
    const [inputValue, setInputValue] = useState('');



    console.log(inputValue, 'inputValue');
    const handleInputChange = (newValue) => {
        console.log(newValue, 'newValuenewValue');
        setInputValue(newValue);
        return false

    };


    const [options, setOptions] = useState([]);

    const handleKeyDown = (event) => {
        console.log('event handleKeyDown', event);
        if (event.key === 'Enter' && inputValue.trim() !== '') {
            setOptions([...options, { value: inputValue, label: inputValue }]);
            setProductOptions(pre => ([...pre, { value: inputValue, label: inputValue }]))
            setInputValue('');
            event.preventDefault();
            return false
        }
        return false
    };


    const handleRemove = (removedValue) => {
        const updatedOptions = options.filter((option) => option.value !== removedValue.value);
        console.log(updatedOptions, "updatedOptions");
        const updatedChipsOptions = productOptions.filter((option) => option.value !== removedValue.value);

        setOptions(updatedOptions);
        setProductOptions(updatedChipsOptions);
    };
    console.log(productOptions, "productOptions", options);

    return (
        <>
            <Modal id="showModal" className="fade zoomIn" size="md" title={title}
                show={open} onHide={() => { setOpen(!open) }} centered>
                <Modal.Header className="px-4 pt-4" closeButton>
                    <h5 className="modal-title fs-18" id="exampleModalLabel">Add Banner Slider</h5>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <FormProvider className="tablelist-form" methods={methods} onSubmit={handleSubmit(onSubmit)} >
                        <Row>
                            <div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
                            <input type="hidden" id="id-field" />
                            {
                                (BannerData?.bannerType == "offerSection" || BannerData?.bannerType == "bannerImage") &&

                                <Col lg={12}>
                                    <div className="mb-3">
                                        <RHSelectField
                                            name='type'
                                            label='Type'
                                            required={true}
                                            list={[
                                                { name: "Category", value: "category" },
                                                { name: "Offer", value: "offer" },
                                                { name: "Normal image", value: "normalImage" }
                                            ]}
                                        />
                                    </div>
                                </Col>

                            }
                            {console.log(getValues()?.type, "getValues")}
                            {


                                !['offer', 'normalImage'].includes(getValues()?.type) ?
                                    <>
                                        <Col lg={12}>
                                            <div className="mb-3">
                                                <Form.Label htmlFor="product-title-input" required>Category</Form.Label>

                                            </div>
                                            <Select
                                                // isMulti
                                                type='button'
                                                inputValue={inputValue}
                                                name='categoryId'
                                                onInputChange={handleInputChange}
                                                // onKeyDown={handleKeyDown}
                                                options={categoryData?.response?.map((categories) => {
                                                    return ({ label: categories?.name, value: categories?.id })
                                                })}
                                                placeholder="Select options"
                                                onChange={(e) => {
                                                    setValue('categoryId', e?.value);
                                                    setChipsOptions(e)
                                                    productListFn(`categoryId=["${e?.value}"]`)
                                                }}
                                                // components={{
                                                //     MultiValueRemove: ({ innerProps, data }) => (
                                                //         <div {...innerProps} onClick={() => handleRemove(data)}>
                                                //             &times;
                                                //         </div>
                                                //     ),
                                                // }}

                                                value={chipsOptions}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        border: '1px solid #ced4da',
                                                        borderRadius: '0.25rem',
                                                        boxShadow: 'none',
                                                        '&:hover': {
                                                            borderColor: '#ced4da',
                                                        },
                                                    }),
                                                    multiValueLabel: (provided) => ({
                                                        ...provided,
                                                        color: '#fff',
                                                        backgroundColor: '#007bff',
                                                    }),
                                                    multiValueRemove: (provided) => ({
                                                        ...provided,
                                                        color: '#fff',
                                                        backgroundColor: '#007bff',
                                                        borderRadius: '0.25rem',
                                                        '&:hover': {
                                                            backgroundColor: '#0056b3',
                                                        },
                                                    }),
                                                }}
                                            />

                                        </Col>
                                        <Col lg={12}>
                                            <div className="mb-3">
                                                <Form.Label htmlFor="product-title-input" required>Product</Form.Label>

                                            </div>
                                            <Select
                                                isMulti
                                                type='button'
                                                name='productId'
                                                inputValue={inputValue}
                                                onInputChange={handleInputChange}
                                                onChange={(e) => {
                                                    let productIds = e?.map(it => it?.value)
                                                    setValue('productId', productIds);

                                                    setProductOptions(e)
                                                }}
                                                onKeyDown={handleKeyDown}
                                                placeholder="Select options"
                                                options={productList?.response?.map((product) => {
                                                    return ({ label: product?.productTitle, value: product?.id })
                                                })}
                                                components={{
                                                    MultiValueRemove: ({ innerProps, data }) => (
                                                        <div {...innerProps} onClick={() => handleRemove(data)}>
                                                            &times;
                                                        </div>
                                                    ),
                                                }}

                                                value={productOptions}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        border: '1px solid #ced4da',
                                                        borderRadius: '0.25rem',
                                                        boxShadow: 'none',
                                                        '&:hover': {
                                                            borderColor: '#ced4da',
                                                        },
                                                    }),
                                                    multiValueLabel: (provided) => ({
                                                        ...provided,
                                                        color: '#fff',
                                                        backgroundColor: '#007bff',
                                                    }),
                                                    multiValueRemove: (provided) => ({
                                                        ...provided,
                                                        color: '#fff',
                                                        backgroundColor: '#007bff',
                                                        borderRadius: '0.25rem',
                                                        '&:hover': {
                                                            backgroundColor: '#0056b3',
                                                        },
                                                    }),
                                                }}
                                            />

                                        </Col>
                                    </>
                                    :
                                    <Col lg={12}>
                                        {console.log(img, "img")}
                                        <BannerFileUpload name='image' image={img} setImage={setImg} />

                                        {/* <div className="mb-3">
                                            <input
                                                name='image'
                                                label='Image'
                                                type='file'
                                            />
                                        </div> */}
                                    </Col>

                            }




                            {/* <Col lg={6}>
                                <div className="hstack gap-3 align-items-start">
                                    <div className="flex-grow-1">
                                        <Form.Control
                                            data-choices
                                            data-choices-multiple-remove="true"
                                            placeholder="Enter tags"
                                            type="text"
                                            defaultValue="Cotton"
                                        />
                                    </div>
                                </div>
                            </Col> */}
                            {/* <Col lg={6}>
                                <div className='d-flex'>
                                    {
                                        chips.map(it => (
                                            <div className='bg-info'>
                                                {it}
                                            </div>
                                        ))
                                    }
                                </div>

                                <input value={chipsInput} onChange={e => setChipsInput(e.target.value)} onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        setChips(prev => ([...prev, chipsInput]));
                                        setChipsInput('')
                                    }
                                }} type="text" className='form-control' />
                            </Col> */}


                            <Col lg={12} className="modal-footer">
                                <div className="hstack gap-2 justify-content-end">
                                    <Button className="btn-ghost-danger" onClick={() => { setOpen(!open) }}><i className="ri-close-line align-bottom me-1"></i> Close</Button>
                                    <Button variant='primary' id="add-btn" onClick={onSubmit} type="button">Save</Button>
                                </div>
                            </Col>
                        </Row>
                    </FormProvider>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default CreateBanner;
